// Utilidades para las ubicaciones por defecto de WhatsApp.

// Extrae { lat, lng } de un link de Google Maps.
export const parseGoogleMapsUrl = (url) => {
  if (!url || typeof url !== "string") return null;
  const patrones = [
    /!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/, // ubicación exacta del lugar
    /[?&](?:q|query|ll|destination)=(-?\d+\.\d+),(-?\d+\.\d+)/, // ?q=lat,lng
    /@(-?\d+\.\d+),(-?\d+\.\d+)/, // /@lat,lng,zoom (centro de cámara, último recurso)
  ];

  for (const re of patrones) {
    const m = url.match(re);
    if (m) {
      const lat = parseFloat(m[1]);
      const lng = parseFloat(m[2]);
      if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
    }
  }
  return null;
};


export const bboxDe = (lat, lng) =>
  `${lng - 0.005},${lat - 0.005},${lng + 0.005},${lat + 0.005}`;
